import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '../../../../BaseComponents/Image'

type SmallPodcastListTeaserImageProps = {
    imageUrl: string
    alt?: string
}

const SmallPodcastListTeaserImage = ({
    imageUrl,
    alt,
}: SmallPodcastListTeaserImageProps): ReactElement => {
    return (
        <Grid noExpand width={46} height={46} minWidth={46}>
            <Image
                size="S"
                imageUrl={imageUrl}
                alt={alt}
                width="100%"
                radiusType="rounded"
                aspectRatio="1:1"
            />
        </Grid>
    )
}

export default SmallPodcastListTeaserImage
